export default "__VITE_ASSET__67835702__"